module.exports = __webpack_public_path__ + "img/kr-product-card3-step3.3ad1c1a.png";